import { FunctionComponent, ReactNode } from "react";

// Define a generic type for the component properties
type DataDisplayProps<K extends string> = {
  render?: (value: string | null) => ReactNode;
  id: K;
  plural?: boolean;
  dictionary: Record<K, string | null>;
  pluralDictionary?: Partial<Record<K, string>>;
};

export type DataDisplayComponent<T extends string> = FunctionComponent<
  Pick<DataDisplayProps<T>, "render" | "id" | "plural">
>;

// Define the main DataDisplay component with generic type
export default function DataDisplay<K extends string>({
  id,
  plural,
  dictionary,
  pluralDictionary,
  render,
}: DataDisplayProps<K>) {
  /** Try grabbing plural if needed */
  const data = (plural && pluralDictionary?.[id]) || dictionary[id] || null;

  if (typeof render === "function") {
    return <>{render(data)}</>;
  }
  return <>{data}</>;
}
